// lib/hooks/useLocations.ts
import useSWR from "swr";
import { City, Country, State } from "./types";
import axios from "axios";

const axiosFetcher = (url: string) => axios.get(url).then((res) => res.data);

export const useCountries = () => {
  return useSWR<Country[]>("/api/countries", axiosFetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 60 * 60 * 1000, // 1 hour cache
  });
};

export const useStates = (countryIso?: string) => {
  return useSWR<State[]>(
    countryIso ? `/api/states?countryIso=${countryIso}` : null,
    axiosFetcher,
    { revalidateOnFocus: false }
  );
};

export const useCities = (countryIso?: string, stateIso?: string) => {
  return useSWR<City[]>(
    countryIso && stateIso
      ? `/api/cities?countryIso=${countryIso}&stateIso=${stateIso}`
      : null,
    axiosFetcher,
    { revalidateOnFocus: false }
  );
};
